/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AssignmentListing from "./AssignmentListing";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setAssigmentsItems,
  setIsTableLoading,
  setTotalItems,
} from "src/redux/slices/AssignmentSlice";
import AssignDialogFormWrapper from "../AssignDialog/AssignDialogFormWrapper";
import { setItems } from "src/redux/slices/BatchSlice";
import { useGetBatchesQuery } from "src/services/BatchServices";
import { useParams } from "react-router-dom";
import {
  useGetAllbatchesAssigmentsWithPaginationQuery,
} from "src/services/QuestionBankServices";

type Props = {};

const AssignmentListingWrapper = (props: Props) => {
  const { batchId } = useParams();
  const dispatch = useDispatch(); 

  //API
  const [openAssignDialog, setOpenAssignDialog] = useState(false);
  const [batchData, setBatchData] = useState<any>();
  

  //Redux state
  const {
    assignmentItems,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isTableLoading,
  } = useSelector((state: RootState) => state.assignment);
  const { items } = useSelector((state: RootState) => state.batch);
  
  //API 
  const {
    data: batchsData,
    isLoading: batchDataIsLoading,
    isFetching: batchDataIsFetching,
  } = useGetBatchesQuery({
    limit: 10,
    searchValue: "",
    params: [
      "batchName",
      "batchCourses",
      "modeId",
      "branchId",
      "allBranches",
      "startDate",
      "estimatedEndDate",
      "time",
      "trainers",
      "language",
      "fees",
      "noOfSeats",
    ],
    page: 1,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  //Get List Data Api

  const {
    data: questionData,
    isLoading: questionDataIsLoading,
    isFetching: questionDataIsFetching,
  } = useGetAllbatchesAssigmentsWithPaginationQuery({
    body: {
      limit: rowsPerPage,
      searchValue: searchValue ,
      params: ["questionLabel", "studentLabel", "remark"],
      page: page,
      filterBy: [],
      dateFilter: {},
      orderBy: "createdAt",
      orderByValue: -1,
      isPaginationRequired: false,
    },
    id: batchId,
  });

 //set Batch Data
  useEffect(() => {
    if (!batchDataIsLoading && !batchDataIsFetching) {
      dispatch(setItems(batchsData?.data));
    }
  }, [batchDataIsLoading, batchDataIsFetching, batchsData]);

  useEffect(() => {
    setBatchData(items?.find((el: any) => el?._id === batchId));
  }, [batchData, items, batchId]);


    // Set List Data
  useEffect(() => {
    if (questionDataIsLoading || questionDataIsFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setAssigmentsItems(questionData?.data || []));
      dispatch(setTotalItems(questionData?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionData, questionDataIsLoading, questionDataIsFetching]);

  return (
    <div>
      <div>
        <AssignmentListing
          rows={assignmentItems}
          onAddNew={() => {
            setOpenAssignDialog(true);
          }}
          paginationProps={{
            isTableLoading,
            totalItems,
            page,
            rowsPerPage,
            searchValue,
            setPage: (newPage) => dispatch(setPage(newPage)),
            setRowsPerPage: (newRowsPerPage) =>
              dispatch(setRowsPerPage(newRowsPerPage)),
            setSearchValue: (newValue: any) =>
              dispatch(setSearchValue(newValue)),
          }}
        />
      </div>
      {openAssignDialog ? (
        <AssignDialogFormWrapper
          batchData={batchData}
          onClose={() => {
            setOpenAssignDialog(false);
          }}
        />
      ) : null}
    </div>
  );
};

export default AssignmentListingWrapper;
